import { render, staticRenderFns } from "./MarketingEmailFormModelsItem.vue?vue&type=template&id=0fed85c2&scoped=true"
import script from "./MarketingEmailFormModelsItem.vue?vue&type=script&lang=js"
export * from "./MarketingEmailFormModelsItem.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailFormModelsItem.vue?vue&type=style&index=0&id=0fed85c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed85c2",
  null
  
)

export default component.exports